/**
 * Author: postcodex
 * Date: 2018/08/23
 * Time: 1:57 PM
 */
import { combineReducers } from 'redux';
import AppReducer from './app';

export default combineReducers(
	{
		app : AppReducer
	}
);
